export default __webpack_public_path__ + "static/media/Desktop-HOT-DEALS.5bc83082.jpg";